import { cn } from '@/lib/utils'

interface HeroSimpleProps {
  title: string
  subtitle?: string
  variant?: 'dark' | 'light' | 'primary'
  className?: string
  children?: React.ReactNode
  watermark?: React.ReactNode
}

export function HeroSimple({
  title,
  subtitle,
  variant = 'dark',
  className,
  children,
  watermark,
}: HeroSimpleProps) {
  const variants = {
    dark: 'bg-ink-deep text-white',
    light: 'bg-cream text-ink',
    primary: 'bg-primary text-ink',
  }

  return (
    <section
      className={cn(
        'relative pt-32 pb-16 md:pt-40 md:pb-24 overflow-hidden',
        variants[variant],
        className
      )}
    >
      {watermark && (
        <div
          className="absolute bottom-0 right-0 translate-x-1/4 translate-y-1/4 pointer-events-none select-none"
          aria-hidden="true"
        >
          {watermark}
        </div>
      )}
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-h1">{title}</h1>
          {subtitle && (
            <p
              className={cn(
                'mt-4 text-lead',
                variant === 'dark' ? 'text-white/80' : 'text-ink/80'
              )}
            >
              {subtitle}
            </p>
          )}
          {children && <div className="mt-8">{children}</div>}
        </div>
      </div>
    </section>
  )
}
